var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.homeRoute,"exact":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var navigate = ref.navigate;
return [_c('a',{staticClass:"logo",attrs:{"href":href},on:{"click":function($event){return _vm.handleClick($event, navigate)}}},[_c('img',{attrs:{"alt":"Logo","src":require("@/assets/zire/z-logo-sm-white.svg")}})])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }